import {
  normalizeLearningCenterHubJson,
  type LearningCenterHubJson,
} from '@/types/learningCenterHubJson';

/** Default copy for the standalone `/learning-center` hub (no runtime JSON fetch). */
const learningCenterHubDefaultsRaw: LearningCenterHubJson = {
  heroDescription:
    'Get important information on what to expect before your learning journey begins.',
  progressLabels: {
    none: "Let's get started!",
    partial: "You're on your way!",
    complete: 'All done!',
  },
  countFormat: '{completed}/{total} complete',
  seeMoreLabel: 'See more',
  seeLessLabel: 'See less',
  emptyStateMessage: 'No items available yet.',
};

export const LEARNING_CENTER_HUB_CONFIG = normalizeLearningCenterHubJson(learningCenterHubDefaultsRaw);
